import StyleSheet from 'styles'

export default StyleSheet({
  section: {
    marginBottom: 50,
    position: 'relative'
  },
  addButton: {
    backgroundColor: '#b9b39b',
    color: 'white',
    marginBottom: 20,
    '&:hover': {
      backgroundColor: '#c2bca4',
    }
  },
  nestedHeading: {
    position: 'relative',
    top: '-50px'
  },
  sectionDelete: {
    float: 'right',
    marginTop: -42,
  },
  headlineLink: {
    position: 'absolute',
    top: 40,
    right: 10,
    color: '#6AAEAA',
    fontWeight: 'bold',
    fontSize: '14px',
  },
  checkList: {
    listStyle: 'none',
    padding: 0,
    marginTop: 30,
    borderRadius: 2,
    '& li': {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: 15,
      '& a': {
        fontSize: 'inherit',
        fontWeight: 'inherit',
      },
      '& i': {
        display: 'block',
        paddingTop: 7,
        fontWeight: 100
      },
    }
  },
  listCheckbox: {
    marginTop: -9
  },
  kycStatus: {
    color: '#586c7b',
    fontWeight: 'bold',
    position: 'absolute',
    top: -10,
    right: -6,
    height: 18,
    overflow: 'hidden',
    padding: 12,
    backgroundColor: '#FFF',
    borderRadius: 4,
    transition: '300ms',
    '@media(max-width: 600px)': {
      maxWidth: 69,
    },
    '&$hoverable:hover': {
      '@media(hover:hover)': {
        height: 125,
        boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
        maxWidth: 200,
      }
    },
    '&$active': {
      height: 125,
      boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
      maxWidth: 200,
    },
    '&$failed': {
      color: '#6AAEAA',
      '& $statusIcon': {
        borderColor: '#6AAEAA',
      }
    },
    '&$pending': {
      color: '#f5bd23',
      '& $statusIcon': {
        borderColor: '#f5bd23',
      }
    },
    '&$complete': {
      color: '#90c814',
      '& $statusIcon': {
        borderColor: '#90c814',
      }
    }
  },
  statusIcon: {
    borderRadius: '15px',
    border: '3px solid #586c7b',
    width: 30,
    height: 30,
    boxSizing: 'border-box',
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 10,
    '& img': {
      width: 24,
      height: 24,
    },
  },
  statusLabel: {
    textAlign: 'right',
    marginBottom: 10,
    cursor: 'pointer',
    maxWidth: '100%',
  },
  statusText: {
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: 'calc(100% - 69px)'
  },
  moreIcon: {
    marginLeft: 5,
    verticalAlign: 'middle',
    transform: 'rotate(0deg)',
    transition: '300ms',
  },
  active: {
    '& $moreIcon': {
      transform: 'rotate(180deg)',
    }
  },
  hoverable: {},
  complete: {},
  pending: {},
  failed: {},
  thirdWidth: {
    width: '33.33333%',
    '@media(max-width: 600px)': {
      width: '50%',
    }
  },
  fullWidth: {
    width: '100%'
  },
  disabledArea: {
    '& button': {
      visibility: 'hidden'
    },
    '& a': {
      visibility: 'hidden'
    }
  },
  checkContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    '& p': {
      flex: 1
    }
  },
  draft: {
    color: '#586c7b'
  },
  registered: {
    color: '#90c814'
  },
  pending_review: {
    color: '#f5bd23'
  },
  approved: {
    color: '#90c814'
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  }
})